import React, { Component } from 'react';
import {
  BrowserRouter as Router,
  Route,
  Switch,
} from 'react-router-dom';

import './App.css';

import Header from './Header';
import Footer from './Footer';
import StartPage from './StartPage';
import PageEmpresa from './Pages/PageEmpresa';
import PageLocalizacao from './Pages/PageLocalizacao';
import PageProdutos from './Pages/PageProdutos';
import PageContato from './Pages/PageContato';
import PageILPF from './Pages/PageILPF';

class App extends Component {
  render() {
    return (
      <div className="div">         
         <Router>
            <div>
            <Header />
            <Switch>
                <Route exact path="/empresa" component={PageEmpresa} />       
                <Route exact path="/localizacao" component={PageLocalizacao} />
                <Route exact path="/produtos" component={PageProdutos} />
                <Route exact path="/contato" component={PageContato} />
                <Route exact path="/ilpf" component={PageILPF} />
                <Route path="/" component={StartPage} />
            </Switch>
            <Footer />
            </div>
        </Router>        
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js